/**
 * Fade-in for contact page cards as they enter the viewport.
 * Observes real block elements (not the <widget-section> host, which can
 * have a 0-height box) and shows anything already on screen immediately.
 */
(function contactReveal($) {
	$(document).on('cms.ready', init);

	var SELECTOR = [
		'.contact-project__wizard',
		'.contact-project__halo',
		'.contact-project__trust',
		'.contact-map__card'
	].join(',');

	function init() {
		var $targets = $(SELECTOR);
		if (!$targets.length) return;

		if ($('body.logged-in').length
			|| (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)
			|| !('IntersectionObserver' in window)) {
			$targets.addClass('is-in');
			return;
		}

		var observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (!entry.isIntersecting) return;
				$(entry.target).addClass('is-in');
				observer.unobserve(entry.target);
			});
		}, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0 });

		$targets.each(function () {
			var el = this;
			var rect = el.getBoundingClientRect();
			var view = window.innerHeight || document.documentElement.clientHeight;
			if (rect.bottom > 48 && rect.top < view - 48) {
				window.requestAnimationFrame(function () {
					$(el).addClass('is-in');
				});
			} else {
				observer.observe(el);
			}
		});
	}
})(jQuery);
